angular.module('nfseApp')
    .controller('CancelamentoServicoDeclaradoController',
        function ($scope, ServicoDeclarado, entity, SweetAlert, $modalInstance, Account) {

            $scope.servicoDeclarado = entity;
            $scope.podeSolicitar = false;
            $scope.cancelando = false;

            console.log($scope.servicoDeclarado);

            if (!$scope.servicoDeclarado.declaracaoPrestacaoServico.cancelamento ||
                !$scope.servicoDeclarado.declaracaoPrestacaoServico.cancelamento.situacaoFiscal ||
                $scope.servicoDeclarado.declaracaoPrestacaoServico.cancelamento.situacaoFiscal == 'NAO_DEFERIDO') {
                $scope.podeSolicitar = true;
                $scope.cancelamento = {servicoDeclarado: entity};
                Account.get().$promise
                    .then(function (account) {
                        $scope.cancelamento.usuarioTomador = account.data;
                    });
            }

            $scope.cancelarServicoDeclarado = function () {
                SweetAlert.swal({
                        title: "Confirme o cancelamento",
                        text: "Você tem certeza que quer cancelar o Serviço Declarado?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                        cancelButtonText: "Não",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm && !$scope.cancelando) {
                            $scope.cancelando = true;
                            ServicoDeclarado.cancelar($scope.cancelamento, function (data) {
                                $modalInstance.close(data);
                            });
                        }
                    });
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        });

